import { render, staticRenderFns } from "./minimal-experiences.vue?vue&type=template&id=02470dca"
import script from "./minimal-experiences.vue?vue&type=script&lang=js"
export * from "./minimal-experiences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports